import BetaLabel from '@anm/components/BetaLabel';
import Tooltip from '@anm/components/Tooltip';
import { ButtonVariants } from '@anm/components/buttons/Button';
import noop from '@anm/helpers/noop';
import { FC } from 'react';

import { ButtonWrapper, Wrapper } from './Wrapper';
import { CardVariants } from '../../Card';

type NewStreamButtonProps = {
  iconName: string;
  onClick: () => void;
  text?: string;
  variant?: ButtonVariants;
  isPending?: boolean;
  showBetaLabel?: boolean;
  tooltipDelayHide?: number;
  tooltipDelayShow?: number;
  isStreamButtonDisabled?: boolean;
  renderTooltip?(): JSX.Element;
  tooltipVariant?: CardVariants;
};

const NewStreamButton: FC<NewStreamButtonProps> = ({
  onClick,
  iconName,
  variant = 'red',
  text = 'New stream',
  isPending,
  renderTooltip,
  tooltipDelayHide = 300,
  tooltipDelayShow = 300,
  showBetaLabel = false,
  tooltipVariant = 'black',
  isStreamButtonDisabled = false
}) => (
  <Wrapper>
    <Tooltip
      withArrow
      variant={tooltipVariant}
      direction="to-bottom"
      delayShow={tooltipDelayShow}
      delayHide={tooltipDelayHide}
      renderContent={renderTooltip}
    >
      <ButtonWrapper
        size="big"
        {...{ variant }}
        icon={`images/icons/${iconName}.svg`}
        disabled={isStreamButtonDisabled}
        isPending={isPending}
        onClick={isStreamButtonDisabled ? noop : onClick}
      >
        {text}
      </ButtonWrapper>
      {showBetaLabel && <BetaLabel positionVariant="top-right" />}
    </Tooltip>
  </Wrapper>
);

export default NewStreamButton;
